// extracted by mini-css-extract-plugin
module.exports = {"headline":"bLfYt-","hero":"_20JAL-","heroLeft":"_3GleB-","heroRight":"weyFT-","reminderItem":"_2XR3z-"};